import { z } from "zod";
import toFirestoreSchema from "../utils/toFirestoreSchema";
import { USER_LEAVE_TEXT_MAX } from "./users.schema";

/**
 * ATTENDANCE SCHEMA
 * Join table tracking user attendance for sessions
 * Status is inferred from the presence of attendedAt/cancelledAt:
 */
export const AttendanceSchema = z.object({
    /** Optional reason for one-off absence or cancellation for this booking (not profile-level leave) */
    absenceReason: z.string().max(USER_LEAVE_TEXT_MAX).optional().describe("Per-booking absence or cancellation note"),
    /** When the user attended (if applicable) */
    attendedAt: z.date().optional().describe("When the user attended"),

    /** When the booking was made */
    bookedAt: z.date().describe("When the booking was made"),

    /** Reference to the book  */
    bookId: z.string().describe("Reference to book document"),

    /** When the booking was cancelled (if applicable) */
    cancelledAt: z.date().optional().describe("When the booking was cancelled"),

    /** Unique attendance identifier */
    id: z.string().describe("Unique attendance identifier"),

    /** When the attendance was resolved by the system or manually by the admin
     * This field makes it easier to query for pending attendance records and resolve them in bulk
     */
    resolvedAt: z.date().optional().describe("When the attendance was resolved"),

    /** Reference to the session */
    sessionId: z.string().describe("Reference to session document"),

    /** Session date and time (denormalized for queries) */
    sessionScheduledAt: z.string().datetime().describe("Session date and time in UTC (ISO datetime, denormalized)"),

    /** The table number assigned to the user (if applicable) */
    tableNumber: z.number().positive().nullable().default(null).describe("The table number assigned to the user"),

    /** Reference to the user */
    uid: z.string().describe("Reference to user document"),

    /** Whether the user was absent */
    wasAbsent: z.boolean().describe("Whether the user was absent"),
});

export const AttendanceRecordSchema = toFirestoreSchema(AttendanceSchema);

// Type export
export type Attendance = z.infer<typeof AttendanceSchema>;
export type AttendanceRecord = z.infer<typeof AttendanceRecordSchema>;
